document.getElementById("scroll-down").addEventListener("click", () => {
    const nextSection = document.querySelector(".textimage-section-wrapper");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  });